import {AxiosBaseQuery} from "../../configs/Axios";
import {createApi} from "@reduxjs/toolkit/query/react";

export const MedicationPlan = 'MedicationPlan';
export const Ingredient = 'Ingredient';
export const Medicine = 'Medicine';
export const Anamnesis = 'Anamnesis';
export const Laboratory = 'Laboratory';
export const MyDefaultLabUnits = 'MyDefaultLabUnits';
export const UserDetails = 'UserDetails';
export const PatientInvitedEmails = 'PatientInvitedEmails';
export const PatientCareProviders = 'PatientCareProviders';
export const CareProviders = 'CareProviders';
export const Patient = 'Patient';
export const PatientList = 'PatientList';
export const FILE = 'File';
export const DOCUMENT_LINK = 'DocumenLink';
export const AccessAssignments = 'AccessAssignments';
export const AGREEMENT = 'AGREEMENT';
export const PROGRAMS = 'PROGRAMS';
export const LETTERS = 'LETTERS';
export const FILTERS = 'FILTERS';
export const COHORTS = 'COHORTS';
export const AI_TOKEN_USAGE = 'AI_TOKEN_USAGE';
export const CLINICAL_REPORT_ANONYMIZATION_GLOBAL_SETTING = 'CLINICAL_REPORT_ANONYMIZATION_GLOBAL_SETTING';

const tagTypes = [
    MedicationPlan,
    Ingredient,
    Medicine,
    Anamnesis,
    Laboratory,
    Patient,
    FILE,
    DOCUMENT_LINK,
    AccessAssignments,
    AGREEMENT,
    PROGRAMS,
    LETTERS,
    CareProviders,
    AI_TOKEN_USAGE,
    CLINICAL_REPORT_ANONYMIZATION_GLOBAL_SETTING
];

const HMOApi = createApi({
    reducerPath: 'hmoApi',
    tagTypes,
    baseQuery: AxiosBaseQuery({ baseUrl: '' }),
    endpoints: () => ({}),
    refetchOnMountOrArgChange: 20,
});
export default HMOApi;
